<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationCustomPageLinks.vue is part of event_pass_client.dev.
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationCustomPageLinks.vue can not be copied and/or distributed    -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 07/03/2018--><!--//Time: 00:25-->

<template>
    <section class="">
        <ul class="magic-line d-none d-md-flex d-md-block justify-content-center align-items-center"
            v-bind:ref="'magic_line_wrapper'"
        >
            <li class=""
                :class="{  current_page_class:currentLocation === '/' }"
                v-bind:ref="currentLocation === '/'? current_page_class: uniqueId()"
            >
                <a href="/"
                   class="nav-item"
                >
                    <i class="material-icons" aria-hidden="true">home</i>
                </a>
            </li>
            <li v-for="page,index in pages.main"
                :key="index"
                :class="{ current_page_class: currentLocation === '/'+page.route }"
                v-bind:ref="currentLocation === '/'+page.route? current_page_class: uniqueId()"
                class="text-uppercase"
            >
                <a class="nav-item"
                   :href="'/'+page.route"
                >{{page.title}}</a>
            </li>
            <li v-bind:ref="'magic_line'"
                :id="magic_line_id"
                class="magic-line-effect"
            ></li>
        </ul>
    </section>
</template>

<script>
	import magicLine from '../../../js/components/effects/custom-magic-line-navigation';
	import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

	export default {
		name: "main-navigation-custom-page-links",
		components: {},
		props: {
			pages:{
				type:Object
            }
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

			this.$nextTick(function () {
				this.loadMagicLine();

			})
		},
		data() {
			return {
				magic_line_id: uniqueId('magic_line_id'),
				currentLocation: location.pathname,
				current_page_class: 'current_page_item',
				current_page: Object
			}
		},
		methods: {
			loadMagicLine() {
				let _this = this;
				setTimeout(function () {
					if (typeof  _this.$refs[_this.current_page_class] !== 'undefined' && _this.$refs[_this.current_page_class] !== null) {
						let magicLineOptions = {
							magic_line_id: _this.magic_line_id,
							current_page_class: '.' + _this.current_page_class,
							current_page: (typeof  _this.$refs[_this.current_page_class] === Array) ? _this.$refs[_this.current_page_class][0] : _this.$refs[_this.current_page_class],
							magic_line: _this.$refs['magic_line']
						};
						magicLine(_this.$refs['magic_line_wrapper'],magicLineOptions);
					}
				}, 400);
			},
			uniqueId() {
				return uniqueId();
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationCustomPageLinks.vue